<app-details-tab [loading]="loading" [toolbarItems]="toolbarItems" [model]="model" [errorMessage]="errorMessage">
  <br />
  <app-vehicle-document-grid [model]="model"></app-vehicle-document-grid>
</app-details-tab>
